const EN_US = {
  'inventoryFileCollectionMapping.sidebarTitle': 'Inventory Mapping Tool',
  'inventoryFileCollectionMapping.title': 'Inventory File Collection Mapping Tool',
  'inventoryFileCollectionMapping.create': 'Create Collection Mapping',
  'inventoryFileCollectionMapping.enroll': 'Enroll Collection',

  'inventoryFileCollectionMapping.mappings.title': 'Current Collection Mappings',
  'inventoryFileCollectionMapping.mappings.slug': 'Collection Slug',
  'inventoryFileCollectionMapping.mappings.name': 'Collection Name',
  'inventoryFileCollectionMapping.mappings.created': 'Created At',
  'inventoryFileCollectionMapping.mappings.noResults': 'No mappings found',
  'inventoryFileCollectionMapping.mappings.delete.success': 'Successfully removed mapping',
  'inventoryFileCollectionMapping.mappings.delete.failure': 'Failed to remove mapping',

  'inventoryFileCollectionMapping.mismatches.title': 'Inventory File Mismatches',
  'inventoryFileCollectionMapping.mismatches.slug': 'Collection Slug',
  'inventoryFileCollectionMapping.mismatches.code': 'Code',
  'inventoryFileCollectionMapping.mismatches.lastSeen': 'Last Seen At',
  'inventoryFileCollectionMapping.mismatches.count': 'Count Over Last 7 Days',
  'inventoryFileCollectionMapping.mismatches.noResults': 'No mismatches found',

  'inventoryFileCollectionMapping.enrolled.title': 'Enrolled Collections',
  'inventoryFileCollectionMapping.enrolled.slug': 'Collection Slug',
  'inventoryFileCollectionMapping.enrolled.name': 'Collection Name',
  'inventoryFileCollectionMapping.enrolled.status': 'Status',
  'inventoryFileCollectionMapping.enrolled.noResults': 'No enrolled collections found',
  'inventoryFileCollectionMapping.enrolled.delete.success': 'Successfully removed collection',
  'inventoryFileCollectionMapping.enrolled.delete.failure': 'Failed to remove collection',

  'inventoryFileCollectionMapping.createModal.title': 'Create Inventory File Mapping',
  'inventoryFileCollectionMapping.createModal.retailerCollection.label': 'Retailer Collection',
  'inventoryFileCollectionMapping.createModal.retailerCollection.description':
    'The retailer collection you want the products to go into.',
  'inventoryFileCollectionMapping.createModal.slug.label': 'Collection Slug',
  'inventoryFileCollectionMapping.createModal.slug.description':
    'The collection slug passed in the inventory file.',
  'inventoryFileCollectionMapping.createModal.required': 'Field is required',
  'inventoryFileCollectionMapping.createModal.failure': 'Failed to create collection mapping',
  'inventoryFileCollectionMapping.createModal.success': 'Successfully created',
  'inventoryFileCollectionMapping.createModal.submitButton': 'Create Inventory File Mapping',

  'inventoryFileCollectionMapping.enrollModal.title': 'Enroll Collection in Inventory Files',
  'inventoryFileCollectionMapping.enrollModal.retailerCollection.label': 'Retailer Collection',
  'inventoryFileCollectionMapping.enrollModal.retailerCollection.description':
    'The retailer collection you want to enroll.',
  'inventoryFileCollectionMapping.enrollModal.required': 'Field is required',
  'inventoryFileCollectionMapping.enrollModal.failure': 'Failed to enroll collection',
  'inventoryFileCollectionMapping.enrollModal.success': 'Successfully enrolled collection',
  'inventoryFileCollectionMapping.enrollModal.submitButton': 'Enroll Collection',
} as const

export default EN_US
